<template>
  <div class="fund-style">
    <!-- <MoreTitle title="投资风格" />
    <div class="row-wrapper">
      <RowInfo label="资产类别">{{ $digitjs(data.assetClass).isNull() }}</RowInfo>
      <RowInfo label="投资地区">{{ $digitjs(data.investmentArea).isNull() }}</RowInfo>
    </div> -->
    <MoreTitle title="投资目标" />
    <div class="row-wrapper">
      <!-- <RowInfo label="资产类别">{{ $digitjs(data.assetClass).isNull() }}</RowInfo>
      <RowInfo label="投资地区">{{ $digitjs(data.investmentArea).isNull() }}</RowInfo> -->
      {{ data ?? '--' }}
    </div>
  </div>
</template>

<script>
import RowInfo from '@/components/common/RowInfo.vue'
export default {
  components: { RowInfo },
  props: ['data']
}
</script>

<style lang="scss" scoped>
.fund-style {
  padding: 0 var(--edge-padding) var(--edge-padding);
  background: var(--bg-color-2);
  .row-wrapper {
    color: var(--font-color-1);
    font-size: 14px;
    line-height: 21px;
  }
}
</style>
